import api from './api'

/**
 * Invitations service
 * Handles admin invitation management API calls
 */
const invitationsService = {
  /**
   * Create a new invitation (admin only)
   * @param {string} email - Email address to send invitation to
   * @param {string} role - Role for the invited user ('standard', 'admin', or 'superuser')
   * @returns {Promise<{id: number, email: string, token: string, created_by: object, created_at: string, expires_at: string, is_used: boolean, role: string}>}
   */
  createInvitation: async (email, role = 'standard') => {
    const response = await api.post('/invitations/create/', { email, role })
    return response.data
  },

  /**
   * List all invitations (admin only)
   * @returns {Promise<Array<{id: number, email: string, token: string, created_by: object, created_at: string, expires_at: string, is_used: boolean, used_at: string, used_by: object}>>}
   */
  listInvitations: async () => {
    const response = await api.get('/invitations/')
    return response.data
  },

  /**
   * Revoke/cancel a pending invitation (admin only)
   * @param {number} invitationId - ID of the invitation to revoke
   * @returns {Promise<{message: string, invitation: object}>}
   */
  revokeInvitation: async (invitationId) => {
    const response = await api.post(`/invitations/${invitationId}/revoke/`)
    return response.data
  },
}

export default invitationsService
